import React from 'react';
import './VisitDetails_mobile.css';

export default function VisitDetailsMobile({ visit, onBack, onPrint, onDownloadPDF, pdfRef }) {
    return (
        <div className="mobile-vd-container" dir="rtl">
            <div className="mobile-vd-actions-bar no-print">
                <button className="mobile-vd-btn mobile-vd-back" onClick={onBack}>
                    <i className="fa-solid fa-arrow-right"></i> رجوع
                </button>
                {/* فصل زر الطباعة عن زر تحميل الـ PDF */}
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button className="mobile-vd-btn mobile-vd-print" onClick={onPrint}>
                        <i className="fa-solid fa-print"></i> طباعة
                    </button>
                    <button className="mobile-vd-btn" onClick={onDownloadPDF} style={{ backgroundColor: '#e74c3c', color: 'white' }}>
                        <i className="fa-solid fa-file-pdf"></i> تحميل PDF
                    </button>
                </div>
            </div>

            {/* تغليف المحتوى المراد تصديره بـ id="pdf-content" */}
            <div ref={pdfRef} dir="rtl" style={{ padding: "10px", backgroundColor: "#f4f6f9", textAlign: "right" }}>
                <div className="mobile-vd-header">
                    <i className="fa-solid fa-heart-pulse fa-3x" style={{ color: "#2c3e50" }}></i>
                    <h2>{visit.hospital_details?.name || "مشفى غير معروف"}</h2>
                    <p>التاريخ: {new Date().toLocaleDateString('ar-EG')}</p>
                </div>

                <h1 className="mobile-vd-title">تقرير الحالة (#{visit.id})</h1>

                {/* تفاصيل المريض */}
                <div className="mobile-vd-card">
                    <h3><i className="fa-solid fa-user"></i> معلومات المريض</h3>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">اسم المريض:</span>
                        <span className="mobile-vd-value">{visit.patient_name || visit.patient_details?.name || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">الرقم الوطني:</span>
                        <span className="mobile-vd-value">{visit.patient_national_number || visit.patient_details?.national_number || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">الجنس:</span>
                        <span className="mobile-vd-value">{visit.patient_details?.gender === "male" ? "ذكر" : visit.patient_details?.gender === "female" ? "أنثى" : visit.patient_details?.gender || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">تاريخ الميلاد:</span>
                        <span className="mobile-vd-value">{visit.patient_details?.birth_date || "غير متوفر"}</span>
                    </div>
                </div>

                {/* تفاصيل التشخيص */}
                <div className="mobile-vd-card">
                    <h3><i className="fa-solid fa-stethoscope"></i> معلومات التشخيص</h3>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">المرض المكتشف:</span>
                        <span className="mobile-vd-value">{visit.disease_name || visit.disease_details?.name || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">الرمز (Code):</span>
                        <span className="mobile-vd-value">{visit.disease_code || visit.disease_details?.disease_code || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">تاريخ التشخيص:</span>
                        <span className="mobile-vd-value">{visit.diagnosis_date || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">حالة المريض:</span>
                        <span className="mobile-vd-value">{visit.status === 'infected' ? 'مصاب' : visit.status === 'cured' ? 'متعافي' : visit.status || "غير متوفر"}</span>
                    </div>
                </div>

                {/* الطبيب والمشفى */}
                <div className="mobile-vd-card">
                    <h3><i className="fa-solid fa-user-md"></i> الطبيب والمشفى</h3>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">الدكتور المعالج:</span>
                        <span className="mobile-vd-value">{visit.doctor_name || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">المشفى:</span>
                        <span className="mobile-vd-value">{visit.hospital_details?.name || "غير متوفر"}</span>
                    </div>
                    <div className="mobile-vd-info-row">
                        <span className="mobile-vd-label">الحالة الاجتماعية:</span>
                        <span className="mobile-vd-value">{visit.marital_status || "غير متوفر"}</span>
                    </div>
                </div>

                {/* الموقع الجغرافي */}
                {visit.geodata && (
                    <div className="mobile-vd-card">
                        <h3><i className="fa-solid fa-map-location-dot"></i> الموقع الجغرافي</h3>
                        <div className="mobile-vd-info-row">
                            <span className="mobile-vd-label">خط العرض (Latitude):</span>
                            <span className="mobile-vd-value" dir="ltr">{visit.geodata.latitude}</span>
                        </div>
                        <div className="mobile-vd-info-row">
                            <span className="mobile-vd-label">خط الطول (Longitude):</span>
                            <span className="mobile-vd-value" dir="ltr">{visit.geodata.longitude}</span>
                        </div>
                        <div className="mobile-vd-info-row">
                            <span className="mobile-vd-label">مكان الإصابة:</span>
                            <span className="mobile-vd-value">{visit.geodata.region_type || "غير متوفر"}</span>
                        </div>
                    </div>
                )}

                {/* التقرير الطبي */}
                <div className="mobile-vd-card">
                    <h3><i className="fa-solid fa-file-medical"></i> التقرير الطبي (Diagnose)</h3>
                    <p className="mobile-vd-diagnose-text">
                        {visit.diagnose || "لا يوجد تفاصيل إضافية للتشخيص."}
                    </p>
                </div>

                <div className="mobile-vd-footer">
                    <div>
                        <p style={{ margin: 0, fontWeight: 'bold', color: '#2c3e50' }}>توقيع الطبيب:</p>
                        <div className="mobile-vd-signature"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}